import { render, staticRenderFns } from "./HoldAccountModal.vue?vue&type=template&id=e7af7fd2"
import script from "./HoldAccountModal.vue?vue&type=script&lang=js"
export * from "./HoldAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports